import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ErrorState {
  show: boolean;
  title?: string;
  message?: string;
  i18nKey?: string;
  eyebrow?: string;
  buttonText?: string;
  icon?: string;
  navigateOnClose?: string;
  isWaf?: boolean;
}

const defaultErrorState: ErrorState = {
  show: false,
  title: undefined,
  message: undefined,
  i18nKey: undefined,
  eyebrow: undefined,
  buttonText: undefined,
  icon: undefined,
  navigateOnClose: undefined,
  isWaf: false,
};

const error = createSlice({
  name: 'Error',
  initialState: defaultErrorState,
  reducers: {
    showError: (
      state,
      action: PayloadAction<{
        title?: string;
        message?: string;
        i18nKey?: string;
        eyebrow?: string;
        buttonText?: string;
        icon?: string;
        navigateOnClose?: string;
        isWaf?: boolean;
      }>
    ) => {
      const { title, message, i18nKey, eyebrow, buttonText, icon, navigateOnClose, isWaf } =
        action.payload;
      if (state.show && state.isWaf && !isWaf) {
        return;
      }
      state.show = true;
      state.title = title;
      state.message = message;
      state.i18nKey = i18nKey;
      state.eyebrow = eyebrow;
      state.buttonText = buttonText;
      state.icon = icon;
      state.navigateOnClose = navigateOnClose;
      state.isWaf = isWaf || false;
    },
    hideError: state => {
      state.show = false;
      state.title = undefined;
      state.message = undefined;
      state.i18nKey = undefined;
      state.eyebrow = undefined;
      state.buttonText = undefined;
      state.icon = undefined;
      state.navigateOnClose = undefined;
      state.isWaf = false;
    },
  },
});

export const errorActions = error.actions;
export const errorSelector = (state: { error: ErrorState }) => state.error;

export default error.reducer;
